import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { ILeadReq } from "../../../models/BaseModel";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    activityType: { activityTypeId: number, activityTypeName: string, activityTypeIcon: string, activitiesCount: number }
    req: ILeadReq
    open: boolean
    onSuccess: () => void
    onHide: () => void
    toast: any
}

export interface IAParamValue {
    paramId: number,
    activityId: number,
    name: string,
    type: string,
    isRequired: boolean,
    value?: string
}

type IAPV = Record<number, IAParamValue[]>;

export const ActivityReq = (props: IProps) => {
    const [submitting, setSubmitting] = useState(false);
    const [apv, setAPV] = useState<IAPV>();

    useEffect(() => {
        const loadAllParams = async () => {
            const reqId = props.req.id;
            if (!props.open || !reqId || !props.req.itinerary) return;

            const includedActivities = props.req.itinerary.filter(
                i =>
                    i.isIncluded &&
                    i.activityTypeId === props.activityType.activityTypeId
            );

            if (includedActivities.length === 0) return;

            await Promise.all(
                includedActivities.map(activity =>
                    loadParametersValueOfReq(reqId, activity.activityId)
                )
            );
        };
        loadAllParams();
    }, [props.open, props.req.id, props.req.itinerary, props.activityType.activityTypeId]);

    const loadParametersValueOfReq = async (reqId: number, activityId: number) => {
        setSubmitting(true);
        const response = await Fetch(`ParameterMast/pvor`, "GET", null, `reqId=${reqId}&activityId=${activityId}`, null);
        if (response) {
            const d: IAParamValue[] = await response.json();
            setAPV(prev => ({ ...prev, [activityId]: d }));
        }
        setSubmitting(false);
    }

    const saveToDB = async (d: IAPV) => {
        setSubmitting(true);

        const body: { activityId: number, paramId: number, value: string }[] = [];
        Object.keys(d).forEach(activityIdStr => {
            const activityId = parseInt(activityIdStr);
            d[activityId].forEach(p => {
                body.push({ activityId: activityId, paramId: p.paramId, value: p.value || '' });
            });
        });

        const response = await Fetch(`leadreq/activityReq/${props.req.id}`, 'PUT', body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: 'Updated Successfully', life: 3000 });
            props.onSuccess();
            setAPV(undefined);
        }
        setSubmitting(false);
    }

    function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        if (!apv) return;
        let error = false;
        const params = apv ? Object.values(apv).flat() : undefined;
        params?.forEach(p => {
            if (p.isRequired && p.type === 'string' && (!p.value || p.value.trim() === '')) {
                props.toast.current.show({ severity: 'error', detail: `Please fill the required field: ${p.name}`, life: 3000 });
                error = true;
            } else if (p.type === 'number' && p.isRequired && (!p.value || p.value.trim() === '')) {
                props.toast.current.show({ severity: 'error', detail: `Please fill the required field: ${p.name}`, life: 3000 });
                error = true;
            } else if (p.type === 'number' && ((Number(p.value)) < 0)) {
                props.toast.current.show({ severity: 'error', detail: `Can't be negative, the field: ${p.name}`, life: 3000 });
                error = true;
            }
        });
        if (error) return;
        saveToDB(apv);
    }

    function onParamValueChange(activityId: number, paramId: number, value: string) {
        if (!apv) return;
        const updatedAPV = { ...apv };
        const params = updatedAPV[activityId];
        if (params) {
            const paramIndex = params.findIndex(p => p.paramId === paramId);
            if (paramIndex !== -1) {
                params[paramIndex] = { ...params[paramIndex], value: value };
                updatedAPV[activityId] = params;
                setAPV(updatedAPV);
            }
        }
    }

    function onHide() {
        props.onHide();
        setAPV(undefined);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '800px' }} header={`${props.activityType.activityTypeName} Requirement`} modal className="p-fluid" onHide={onHide}>
            <form onSubmit={(e) => onSubmit(e)} className="p-fluid formgrid grid">
                {
                    apv && Object.keys(apv).map((activityIdStr, i) => {
                        const activityId = parseInt(activityIdStr);
                        return <div className="field col-12" key={activityId}>
                            <h5>{i + 1}. {props.req.itinerary?.find(f => f.activityId === activityId)?.name} :</h5>
                            <div className="grid mt-3">
                                {
                                    apv[activityId].map(p =>
                                    (<div key={p.paramId} className='field col-12 md:col-6'>
                                        <label htmlFor={p.name}>{p.name}{p.isRequired && <span style={{ color: 'red' }}>*</span>}</label>
                                        <InputText value={p.value} type={p.type === 'number' ? 'number' : "text"} onChange={e => { onParamValueChange(p.activityId, p.paramId, e.target.value) }} />
                                    </div>))
                                }
                            </div>
                        </div>
                    })
                }
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}
